import { render, staticRenderFns } from "./SimpleGraph.vue?vue&type=template&id=9c44ec8c&scoped=true&"
import script from "./SimpleGraph.vue?vue&type=script&lang=js&"
export * from "./SimpleGraph.vue?vue&type=script&lang=js&"
import style0 from "./SimpleGraph.vue?vue&type=style&index=0&id=9c44ec8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c44ec8c",
  null
  
)

export default component.exports